module.exports = __webpack_public_path__ + "img/event_banner.d450aa52.png";